import React from 'react'
import SbEditable from 'storyblok-react'
import Slider from 'react-slick'

const QuoteSliderBlock = ({ block, className }) => {
  function NextArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-right"></i>
      </span>
    )
  }

  function PrevArrow(props) {
    const { className, onClick } = props
    return (
      <span className={className} onClick={onClick}>
        <i className="fal fa-chevron-left"></i>
      </span>
    )
  }

  const settings = {
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: block.autoplay === true ? true : false,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow className="slick-prev" />,
    nextArrow: <NextArrow className="slick-next" />,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <SbEditable content={block}>
      <section
        className={`quote-slider-block ${
          block.quote_small === true ? 'quote-small' : ''
        }`}
      >
        <div className="quote-slider-block-container">
          <Slider {...settings} className="quote-slider-block-slider">
            {block.quote_items?.length > 0 &&
              block.quote_items.map((item, index) => (
                <div
                  key={index}
                  className={item.quote_small === true ? 'quote-small' : ''}
                >
                  <blockquote>
                    <p>{item.quote}</p>
                    {item.author?.length > 0 && (
                      <footer>
                        <b>{item.author}</b>
                      </footer>
                    )}
                  </blockquote>
                </div>
              ))}
          </Slider>
        </div>
      </section>
    </SbEditable>
  )
}

export default QuoteSliderBlock
